module.exports = __webpack_public_path__ + "img/floppy.303e9837.svg";